export default function (formId, action = true) {
  const form = typeof formId === 'string' ? document.getElementById(formId) : formId;
  if (!form) {
    console.warn('block resubmit, element not found with ID: ', formId);
    return;
  }
  const resetButtons = form.querySelectorAll('button[type="reset"],input[type=reset]');
  const inputElements = form.querySelectorAll('input');
  const selectElements = form.querySelectorAll('select');
  const textareaElements = form.querySelectorAll('textarea');

  // A field the server registered here holds a value it set itself and the visitor never entered,
  // so a reset has nothing to undo and blanking it would break the submit the server expects.
  // The registration is read on every reset, because scripts may register after this setup runs.
  // Appearance is no substitute for it: a field can be hidden or aria-hidden simply because the
  // section it sits in is collapsed, and that field does have to reset.
  const isPreserved = function (element) {
    const ids = window.NCPreserveOnReset;
    const id = element.getAttribute('id');
    return Boolean(id) && Array.isArray(ids) && ids.indexOf(id) !== -1;
  };
  const clearInput = function (element) {
    if (element.getAttribute('name') === 'n-package') {
      return;
    }
    if (isPreserved(element)) {
      return;
    }
    switch (element.type) {
      case 'checkbox':
      case 'radio':
        if (element.checked) {
          element.checked = false;
          element.removeAttribute('checked');
        }
        break;
      case 'range':
        const method = element.getAttribute('data-filter-method');
        if (method === 'greater_or_equal') {
          element.value = null;
          if (element.hasAttribute('data-min-absolute')) {
            const min = element.getAttribute('data-min-absolute');
            element.setAttribute('min', min);
            element.value = min;
          } else if (element.hasAttribute('min')) {
            element.value = element.getAttribute('min');
          }
          element.setAttribute('value', element.value);
        } else if (method === 'lesser_or_equal') {
          element.value = null;
          if (element.hasAttribute('data-max-absolute')) {
            const max = element.getAttribute('data-max-absolute');
            element.setAttribute('max', max);
            element.value = max;
          } else if (element.hasAttribute('max')) {
            element.value = element.getAttribute('max');
          }
          element.setAttribute('value', element.value);
        } else {
          element.value = null;
          element.removeAttribute('value');
        }
        break;
      default:
        element.value = null;
        element.removeAttribute('value');
        break;
    }
  };
  const clearSelect = function (element) {
    if (isPreserved(element)) {
      return;
    }
    const multiple = element.hasAttribute('multiple');
    for (let i = 0; i < element.options.length; i++) {
      const option = element.options[i];
      option.checked = !multiple && i === 0;
      if (option.checked) {
        option.setAttribute('selected', true);
      } else {
        option.removeAttribute('selected');
      }
    }
  };
  const clearTextarea = function (element) {
    if (isPreserved(element)) {
      return;
    }
    element.textContent = '';
  };
  const setupResetButton = function (button) {
    button.addEventListener('click', function () {
      for (let i = 0; i < inputElements.length; i++) {
        clearInput(inputElements[i]);
      }
      for (let i = 0; i < selectElements.length; i++) {
        clearSelect(selectElements[i]);
      }
      for (let i = 0; i < textareaElements.length; i++) {
        clearTextarea(textareaElements[i]);
      }
      if (action) {
        requestAnimationFrame(function () {
          if (typeof action === 'string') {
            window.location.href = action;
          } else {
            form.submit();
          }
        });
      }
    });
  };
  for (let i = 0; i < resetButtons.length; i++) {
    setupResetButton(resetButtons[i]);
  }
}